import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "microsoft-outlook",
  "name": "Microsoft Outlook",
  "category": "integrations",
  "description": "Interact with Microsoft Outlook via Microsoft Graph API - send emails, manage drafts, read messages, work with folders, contacts, and calendar events",
  "icon": "microsoft-outlook",
  "iconType": "microsoft-icon",
  "color": "blue",
  "version": "1.0.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Microsoft Outlook",
    "color": "#2372ba"
  },
  "credentials": [
    {
      "name": "microsoft_outlook_oauth",
      "required": false,
      "displayName": "Microsoft Outlook OAuth2",
      "displayOptions": {
        "show": {
          "useCredential": [true]
        }
      }
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "microsoft",
    "outlook",
    "email",
    "mail",
    "calendar",
    "contacts",
    "microsoft-graph",
    "office365",
    "exchange",
    "drafts",
    "attachments"
  ],
  "comingSoon": false
};

export default definition;
